module.exports = __webpack_public_path__ + "static/media/candidatesImage.f5c34644.png";